module.exports = __webpack_public_path__ + "img/brand_01.e2a843e8.png";